export default "__VITE_ASSET__DIXjVKyt__"